import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../Tabels/Tabels.css";
import plus from "../../Components/assets/icons/a1.png";
import colunms from "../../Components/assets/icons/LINES.png";
import pen from "../../Components/assets/icons/pen.png";
import eye from "../../Components/assets/icons/eye.png";
import basket from "../../Components/assets/icons/basket.png";
import search1 from "../../Components/assets/icons/search.png";
import top from "../../Components/assets/icons/top.png";
import Table from "react-bootstrap/Table";
import circle from "../assets/icons/circle.png";
import rigth from "../assets/icons/rigth.png";
import save from "../assets/icons/save.png";
import cancel from "../assets/icons/cross.png";
import { Link, useNavigate, useParams } from "react-router-dom";
import Header from "../Header/Header";

import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Offcanvas from "react-bootstrap/Offcanvas";

import toast, { Toaster } from "react-hot-toast";
import Card from "react-bootstrap/Card";
import Select from "react-select";
import AddOffCanvance from "./Add";
import EditOffCanvance from "./Edit";
import { Container, Row, Col, Button, Form, InputGroup } from "react-bootstrap";
import { Context } from "../../utils/context";
import { FaEye } from "react-icons/fa";
import { formatDate } from "../../utils/common";
import { Controller, useForm } from "react-hook-form";
import { getDownloadDataExcel, postData } from "../../utils/api";
import ViewOffCanvance from "./ViewOffCanvance";
import Pagination_Holder from "../common/Pagination_Holder/Pagination_Holder";

library.add(fas);

// ********************************************************************************************************************************************************

const Tables = () => {
  const {
    getData,
    editStatusData,
    deleteData,
    ErrorNotify,
    isAllow,
    IMG_URL,
    Per_Page_Dropdown,
    Select2Data,
    usertype,
  } = useContext(Context);

  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setperPage] = useState(5);
  const [search, setSearch] = useState("");
  const [resets, setReset] = useState();
  const [show, setShowAdd] = useState(false);
  const [show1, setShowEdit] = useState(0);
  const [option, setOption] = useState();
  const [searchByUser, setSearchByUser] = useState(null);
  const [vender, setvender] = useState("");
  const [studioName, setStudioName] = useState("");

  const { id } = useParams();
  const [totalPages, settotalPages] = useState();
  const [onPageChange, setonPageChange] = useState(1);
  const handlePageChange = (pageNumber) => {
    setonPageChange(pageNumber);
  };

  // Select All Functionality
  const [selectAllChecked, setSelectAllChecked] = useState([]);
  const [allChecked, setAllChecked] = useState([]);

  const handleSelectAll = async () => {
    await setSelectAllChecked(allChecked);
  };

  const handleChange = async (e) => {
    const { value, checked } = e.target;

    if (value === "selectAll") {
      if (checked) {
        handleSelectAll();
      } else {
        await setSelectAllChecked([]);
      }
    } else {
      if (checked) {
        await setSelectAllChecked([...selectAllChecked, Number(value)]);
      } else {
        await setSelectAllChecked(
          selectAllChecked.filter((e) => e !== Number(value))
        );
      }
    }
  };

  useEffect(() => {
    setSearchByUser(id || null); // Set to null if id is undefined or null
    getDataAll();
  }, [id]);

  useEffect(() => {
    getDataAll();
  }, [searchByUser]);

  const [user, setUser] = useState({});
  const GetUserData = async () => {
    const response = await getData(`/usersingleget`);
    if (response?.success) {
      console.log("user :-", response?.data);
      setUser(response?.data);
    }
  };
  useEffect(() => {
    GetUserData();
  }, []);

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
    setValue,
    getValues,
  } = useForm();

  // console.log(getValues("type").value, "Type");

  const type = [
    {
      value: "Hourly",
      label: "Hourly",
    },
    {
      value: "Daily",
      label: "Daily",
    },
  ];

  const [changeStatus, setChangeStatus] = useState();
  const [changeStatusTopStudio, setChangeStatusTopStudio] = useState();
  const [changeStatusPremiumStudio, setChangeStatusPremiumStudio] = useState();
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [searchPaymentStatus, setSearchPaymentSatatus] = useState("");
  const [fromDaily, setFromDaily] = useState("");
  const [toDaily, setToDaily] = useState("");

  const getDataAll = async () => {
    const queryString = `/booking-cancelled?page=${onPageChange}&per_page=${perPage}&term=${search}&vender=${vender || ""
      }&studioName=${studioName || ""}&from=${from ? formatDate(from) : ""} &to=${to ? formatDate(to) : ""
      }&fromdaily=${fromDaily ? formatDate(fromDaily) : ""} &todaily=${toDaily ? formatDate(toDaily) : ""
      }&searchPaymentStatus=${searchPaymentStatus?.value || ""}`;
    const response = await getData(queryString);
    await setData(response);
    setCurrentPage(response?.data?.currentPage);
    setperPage(response?.data?.per_page);
    setSearch(response?.data?.search_name);
    setOption(await Per_Page_Dropdown(response?.data?.totalEntries));
    settotalPages(response?.data?.totalPages);
    console.log("response", response);
    const newData = response?.data?.data;
    if (newData) {
      const newIds = newData.map((d) => d?.id);
      setAllChecked(newIds);
    }
  };
  useEffect(() => {
    getDataAll();
  }, [
    changeStatusTopStudio,
    changeStatusPremiumStudio,
    perPage,
    resets,
    show,
    show1,
    // search,
    // studioName,
    // vender,
    // from,
    // to,
    // fromDaily,
    // toDaily,
    changeStatus,
    onPageChange,
  ]);

  const ChangeStatus = async (id, selectedOption) => {
    try {
      const response = await postData(`/booking-request/request/${id}`, {
        stage: selectedOption.value,
      });
      setChangeStatus(response);
    } catch (error) {
      console.error("Error changing status:", error);
      // Optionally, handle the error by updating the state or showing a message
    }
  };

  const ChangeStatusTopStudio = async (id) => {
    const response = await editStatusData(`/studio/top-studio-status/${id}`);
    setChangeStatusTopStudio(response);
  };

  const ChangeStatusPremiumStudio = async (id) => {
    const response = await editStatusData(
      `/studio/premium-studio-status/${id}`
    );
    setChangeStatusPremiumStudio(response);
  };

  // Delete module.....................................................
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [recordToDeleteId, setRecordToDeleteId] = useState(null);
  const [recordToDeleteName, setRecordToDeleteName] = useState(null);

  const showDeleteRecord = async (id, name) => {
    setShowDeleteModal(true);
    setRecordToDeleteId(id);
    setRecordToDeleteName(name);
  };

  // Modal function
  const handleClose = () => setShowAdd(false);
  const handleShow = () => setShowAdd(true);

  const handleClose1 = () => setShowEdit(0);
  const handleShow1 = (id) => {
    setShowEdit(id);
  };

  const DeleteRecord = async () => {
    setShowDeleteModal(false);
    if (recordToDeleteId) {
      const response = await deleteData(`/studio/${recordToDeleteId}`);
      await ErrorNotify(recordToDeleteName);
      setChangeStatus(response);
      setRecordToDeleteId(null);
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteModal(false);
    setRecordToDeleteId(null);
  };

  //toggle/
  const [visible, setVisibel] = useState({
    col0: true,
    col1: true,
    col2: true,
    col3: true,
    col4: true,
    col5: true,
    col6: true,
    col7: true,
    col8: true,
    col9: true,
    col10: true,
    col11: true,
    col12: true,
    col13: true,
    col14: true,
  });

  //toggle columnns.........
  const toggleColumn = (event, columnName) => {
    event.preventDefault();
    setVisibel((prev) => ({
      ...prev,
      [columnName]: !prev[columnName],
    }));
  };

  const [cities, setCities] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [childSubCategories, setChildSubCategories] = useState([]);

  const GetAllCities = async () => {
    const response = await getData("/allcity");
    if (response?.success) {
      setCities(await Select2Data(response?.data, "city_id"));
    }
  };

  useEffect(() => {
    GetAllCities();
  }, []);

  const [view, setview] = useState(0);
  const handleViewClose = () => setview(false);
  const handleViewshow = async (id) => {
    console.log(id);
    await setview(id);
  };

  const HandleDownload = async () => {
    if (selectAllChecked.length == 0) {
      alert("Please Select Atleast One Record");
    } else {
      try {
        await getDownloadDataExcel(
          "/booking-cancelled/download-bc",
          selectAllChecked,
          "Booking Cancellation list"
        );
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  return (
    <>
      <div className="main-advancedashboard">
        <Header title={"Cancel Bookings "} link={"/booking-rejected"} />
        <section className="AdvanceDashboard">
          <div className="col-xxl-12 col-xl-12  ">
            <div className="row MainRowsec">
              <section className="Tabels tab-radio tab-radio ">
                <div className="">
                  {/* container */}
                  <div className="row">
                    {/* {isAllow.includes(100) ? (
                      <div className="col-xxl-3 col-xl-2 col-lg-4 col-md-6 col-sm-6 col-12">
                        <Link
                          // to="/employee/employee_details/add"
                          type="button"
                          className="btn btn-add pe-3"
                        >
                          <div className="add me-3">
                            <div onClick={() => handleShow()}>
                              <p className="add-sub-txttt">
                                {" "}
                                <img
                                  src={plus}
                                  className="plus me-2 ms-0"
                                  alt=""
                                />
                                Add Studio
                              </p>
                            </div>
                          </div>
                        </Link>
                      </div>
                    ) : (
                      <></>
                    )} */}
                    {/* <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                      <div className="add">
                        <div className="dropdown">
                          <button
                            className="btn btn-columns dropdown-toggle"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <img
                              src={colunms}
                              className="columns me-2 "
                              alt=""
                            />
                            Column Selection{" "}
                            <img src={top} className="top ms-1" alt="" />{" "}
                          </button>
                          <ul className="dropdown-menu">
                            <li>
                              <Link
                                className="dropdown-item"
                                onClick={(event) => toggleColumn(event, "col1")}
                                href="#"
                              >
                                S. No.
                                {visible?.col1 ? (
                                  <FontAwesomeIcon
                                    className="ms-4"
                                    icon="fa-solid fa-eye"
                                  />
                                ) : (
                                  <FontAwesomeIcon
                                    className="ms-4"
                                    icon="fa-solid fa-eye-slash"
                                  />
                                )}
                              </Link>
                            </li>
                            <li>
                              <Link
                                className="dropdown-item"
                                onClick={(event) => toggleColumn(event, "col2")}
                                href="#"
                              >
                                customer Name
                                {visible?.col2 ? (
                                  <FontAwesomeIcon
                                    className="ms-4"
                                    icon="fa-solid fa-eye"
                                  />
                                ) : (
                                  <FontAwesomeIcon
                                    className="ms-4"
                                    icon="fa-solid fa-eye-slash"
                                  />
                                )}
                              </Link>
                            </li>

                            <li>
                              <Link
                                className="dropdown-item"
                                onClick={(event) => toggleColumn(event, "col8")}
                                href="#"
                              >
                                Vendor
                                {visible?.col4 ? (
                                  <FontAwesomeIcon
                                    className="ms-2"
                                    icon="fa-solid fa-eye"
                                  />
                                ) : (
                                  <FontAwesomeIcon
                                    className="ms-2"
                                    icon="fa-solid fa-eye-slash"
                                  />
                                )}
                              </Link>
                            </li>

                            <li>
                              <Link
                                className="dropdown-item"
                                onClick={(event) => toggleColumn(event, "col3")}
                                href="#"
                              >
                                Studio Name
                                {visible?.col5 ? (
                                  <FontAwesomeIcon
                                    className="ms-2"
                                    icon="fa-solid fa-eye"
                                  />
                                ) : (
                                  <FontAwesomeIcon
                                    className="ms-2"
                                    icon="fa-solid fa-eye-slash"
                                  />
                                )}
                              </Link>
                            </li>

                            <li>
                              <Link
                                className="dropdown-item"
                                onClick={(event) => toggleColumn(event, "col4")}
                                href="#"
                              >
                                Date
                                {visible?.col6 ? (
                                  <FontAwesomeIcon
                                    className="ms-2"
                                    icon="fa-solid fa-eye"
                                  />
                                ) : (
                                  <FontAwesomeIcon
                                    className="ms-2"
                                    icon="fa-solid fa-eye-slash"
                                  />
                                )}
                              </Link>
                            </li>

                            <li>
                              <Link
                                className="dropdown-item"
                                onClick={(event) => toggleColumn(event, "col5")}
                                href="#"
                              >
                                Time
                                {visible?.col7 ? (
                                  <FontAwesomeIcon
                                    className="ms-2"
                                    icon="fa-solid fa-eye"
                                  />
                                ) : (
                                  <FontAwesomeIcon
                                    className="ms-2"
                                    icon="fa-solid fa-eye-slash"
                                  />
                                )}
                              </Link>
                            </li>

                            <li>
                              <Link
                                className="dropdown-item"
                                onClick={(event) => toggleColumn(event, "col7")}
                                href="#"
                              >
                                Amount
                                {visible?.col8 ? (
                                  <FontAwesomeIcon
                                    className="ms-4"
                                    icon="fa-solid fa-eye"
                                  />
                                ) : (
                                  <FontAwesomeIcon
                                    className="ms-4"
                                    icon="fa-solid fa-eye-slash"
                                  />
                                )}
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div> */}
                    <div className="border-line mt-3"></div>
                    <div className="row mt-4">
                      <div className="col-md-12 col-12">
                        <div className="d-flex mb-3 align-items-center">
                          <div className="show me-2">
                            <p className="show m-0">Show</p>
                          </div>
                          <div className="number me-2">
                            <select
                              className="form-select form-select-sm"
                              aria-label=".form-select-sm example"
                              onChange={(e) => setperPage(e.target.value)}
                            >
                              {option?.map((option) => (
                                <option key={option} value={option}>
                                  {option}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="entries">
                            <p className="show  m-0">entries</p>
                          </div>
                          <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-2 col-12">
                            <div className="sowing me-2 ms-3">
                              <p className="show  m-0">{`Showing ${Math.min(
                                (currentPage - 1) * perPage + 1
                              )} to ${Math.min(
                                currentPage * perPage,
                                data?.data?.totalEntries
                              )} of ${data?.data?.totalEntries} entries`}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-xxl-12 col-xl-12  col-lg-12  col-md-12 col-12">
                        <div className="row">
                          <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-6 col-12 mb-2">
                            <Form.Label>Customer Name</Form.Label>
                            <div className="num me-2 text-end">
                              <input
                                type="text"
                                className="form-control"
                                id=""
                                placeholder="customer name"
                                value={search}
                                onChange={(e) => {
                                  setSearch(e.target.value);
                                }}
                              />
                            </div>
                          </div>
                          {/* <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-6 col-sm-12 col-12  mb-3">
                            <Form.Label> Payment Status</Form.Label>
                            <div className="num me-2">
                              <Select
                                options={[
                                  { label: "COD", value: "COD" },
                                  { label: "Online", value: "Online" },
                                ]}
                                // value={searchPaymentStatus}
                                placeholder="Payment Status"
                                value={searchPaymentStatus}
                                onChange={(e) => {
                                  setSearchPaymentSatatus(e);
                                }}
                                classNamePrefix="searchProduct"
                              />
                            </div>
                          </div> */}
                          {/* <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-6 col-12 mb-2">
                            <div className="num me-2 text-end">
                              <Form.Label></Form.Label>
                              <input
                                type="text"
                                className="form-control"
                                id=""
                                placeholder="studio name"
                                value={studioName}
                                onChange={(e) => {
                                  setStudioName(e.target.value);
                                }}
                              />
                            </div>
                          </div> */}
                          {/* <div className="Search me-2">
                            <Button
                              type="button"
                              onClick={getDataAll}
                              className="btn btn-search"
                            >
                              <img src={search1} className="search" alt="" />
                            </Button>
                          </div> */}
                          <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-6 col-12 mb-2">
                            <Form.Label> From</Form.Label>
                            <div className="num me-2 text-end">
                              <input
                                type="date"
                                className="form-control"
                                value={fromDaily}
                                onChange={(e) => {
                                  setFromDaily(e.target.value);
                                  setToDaily(""); // Reset the "Daily To" date when "Daily From" changes
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-6 col-12 mb-2">
                            <Form.Label> To</Form.Label>
                            <div className="num me-2 text-end">
                              <input
                                type="date"
                                className="form-control"
                                value={toDaily}
                                onChange={(e) => setToDaily(e.target.value)}
                                min={fromDaily}
                              />
                            </div>
                          </div>
                          <div className="d-flex col-xxl-3 col-xl-3  col-lg-4  col-md-5 col-12 mb-2 mt-3">
                            <button
                              type="button"
                              className="btn btn-search w-100"
                              onClick={HandleDownload}
                            >
                              Download excel
                              <FontAwesomeIcon
                                icon="fa-solid fa-file-lines"
                                className="pdf-icon ms-3"
                                variant="success"
                              // className="btn btn-view"
                              />
                            </button>
                          </div>
                          <div className="col-xxl-1 col-xl-1 col-lg-2 col-md-2 col-sm-6 col-12 ">
                            <Form.Label></Form.Label>
                            <div className="Search-1">
                              <Button
                                type="button"
                                onClick={getDataAll}
                                className="btn btn-search w-100"
                              >
                                <img src={search1} className="search" alt="" />
                              </Button>
                            </div>
                          </div>{" "}
                          <div className="col-xxl-1 col-xl-1 col-lg-2 col-md-6 col-sm-6 col-12 ">
                            <Form.Label></Form.Label>
                            <div className="Search-1">
                              <button
                                type="button"
                                onClick={() => {
                                  setSearch("");
                                  setStudioName("");
                                  setvender("");
                                  setTo("");
                                  setFrom("");
                                  setFromDaily("");
                                  setToDaily("");
                                  setSearchPaymentSatatus("");
                                  setReset(!resets);
                                }}
                                className="btn btn-reset w-100"
                              >
                                Reset
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="border-line mt-3"></div>
                  <div className="row mt-3">
                    <div className="data table-responsive">
                      <Table striped bordered hover responsive center>
                        <thead>
                          <tr className="">
                            {visible.col0 && (
                              <th className="check round-check">
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="selectAll"
                                    checked={
                                      allChecked.length ===
                                      selectAllChecked.length
                                    }
                                    onChange={handleChange}
                                    id="selectAll"
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="flexCheckChecked"
                                  ></label>
                                </div>
                              </th>
                            )}
                            {visible.col1 && <th className="sr">S. No.</th>}
                            {visible.col2 && (
                              <th
                                style={{ width: "900px" }}
                                className="tax-name"
                              >
                                BookingID
                              </th>
                            )}
                            {visible.col3 && (
                              <th
                                style={{ width: "900px" }}
                                className="tax-name"
                              >
                                Customer Name
                              </th>
                            )}
                            {visible.col4 && (
                              <th
                                style={{ width: "900px" }}
                                className="tax-name"
                              >
                                Refund Amount
                              </th>
                            )}
                            {visible.col6 && (
                              <th
                                style={{ width: "900px" }}
                                className="tax-name"
                              >
                                Fare
                              </th>
                            )}
                            {visible.col7 && (
                              <th
                                style={{ width: "1000px" }}
                                className="tax-name"
                              >
                                Cab Type
                              </th>
                            )}
                            {/* {visible.col14 && (
                              <th
                                style={{ width: "1000px" }}
                                className="tax-name"
                              >
                                Cab
                              </th>
                            )} */}
                            {visible.col8 && (
                              <th
                                style={{ width: "900px" }}
                                className="tax-name"
                              >
                                Date
                              </th>
                            )}
                            {visible.col9 && (
                              <th
                                style={{ width: "900px" }}
                                className="tax-name"
                              >
                                Time
                              </th>
                            )}{" "}
                            {visible.col10 && (
                              <th
                                style={{ width: "400px" }}
                                className="tax-name"
                              >
                                Payment Status
                              </th>
                            )}
                            {visible.col10 && (
                              <th
                                style={{ width: "900px" }}
                                className="tax-name"
                              >
                                View Details
                              </th>
                            )}
                            {/* {visible.col11 && (
                              <th className="tax-name">Driver Details</th>
                            )} */}
                            {/* {visible.col12 && (
                              <th className="tax-name">Booking Status</th>
                            )} */}
                            {/* {visible.col13 && (
                              <th className="tax-name">Invoice Download</th>
                            )} */}
                          </tr>
                        </thead>
                        <tbody>
                          {data?.data?.data?.length > 0 ? (
                            data.data.data.map((d, index) => {
                              return (
                                <tr className="" key={index}>
                                  {visible.col0 && (
                                    <td>
                                      <div className="form-check">
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          value={d?.id}
                                          name="perselected"
                                          checked={selectAllChecked.includes(
                                            d?.id
                                          )}
                                          onChange={handleChange}
                                          id="flexCheckDefault"
                                        />
                                        <label
                                          className="form-check-label"
                                          htmlFor="flexCheckDefault"
                                        ></label>
                                      </div>
                                    </td>
                                  )}
                                  {visible.col1 && <td>{++index}.</td>}
                                  {visible.col2 && <td>{d?.booking_id}</td>}
                                  {visible.col3 && (
                                    <td>{d?.user?.first_name}</td>
                                  )}
                                  {visible.col4 && <td>{d?.booking_cancel?.remaing_price}</td>}
                                  {visible.col6 && <td>{d?.fare}</td>}
                                  {/* {visible.col5 && <td>{d?.duration}</td>} */}
                                  {visible.col7 && <td>{d?.cab_type?.name}</td>}
                                  {/* {visible.col14 && <td>{d?.cab?.name}</td>} */}
                                  {visible.col8 && <td>{d?.date}</td>}
                                  {visible.col9 && <td>{d?.time}</td>}
                                  {visible.col10 && (
                                    <td>
                                      <div className="d-flex">
                                        <td>{d?.payment_method}</td>
                                      </div>
                                    </td>
                                  )}
                                  {visible.col10 && (
                                    <td>
                                      <div className="d-flex">
                                        <div className="add">
                                          {" "}
                                          <Link
                                            type="button"
                                            className="btn btn-add pe-3"
                                          >
                                            <div
                                              onClick={() =>
                                                handleViewshow(d.id)
                                              }
                                            >
                                              view
                                            </div>
                                          </Link>
                                        </div>
                                      </div>
                                    </td>
                                  )}

                                  {/* {visible.col11 && (
                                <td>
                                  <div className="d-flex">
                                    {d?.driver_detail !== null ? (
                                      <button
                                        onClick={() => {
                                          handleShow1(d?.id);
                                        }}
                                        type="button"
                                        className="btn btn-primary"
                                      >
                                        Edit Details
                                      </button>
                                      // <EditButton handleShow1={handleShow1} id={d?.id} />
                                    ) : (
                                      <button
                                        onClick={() => {
                                          handleShow(d?.id);
                                        }}
                                        type="button"
                                        className="btn btn-primary"
                                      >
                                        Add Details
                                      </button>
                                    )}
                                  </div>
                                </td>
                              )} */}

                                  {/* {visible.col12 && (
                                <td>
                                  {d?.booking_status_id === 2 ? (
                                    d?.booking_status?.name // Removed the extra braces
                                  ) : (
                                    <div className="d-flex">
                                      <button
                                        onClick={() => {
                                          Accepted(d.id);
                                        }}
                                        type="button"
                                        className="btn btn-primary"
                                      >
                                        Cancel
                                      </button>
                                    </div>

                                  )}
                                </td>
                              )} */}

                                  {/* {visible.col13 && (
                                <td>
                                  <div className="d-flex">
                                    <button
                                      onClick={() =>
                                        handleDownload(d?.invoice)
                                      }
                                      className="btn btn-primary"
                                    >
                                      Download
                                    </button>
                                  </div>
                                </td>
                              )} */}
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td colSpan="20" className="text-center">
                                No Data
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                      <Pagination_Holder
                        onPageChange={currentPage}
                        totalPages={totalPages}
                        handlePageChange={handlePageChange}
                      />
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </section>
      </div>

      {show ? (
        <AddOffCanvance
          handleClose={handleClose}
          setShow={setShowAdd}
          show={show}
        />
      ) : (
        ""
      )}

      {view ? (
        <ViewOffCanvance
          handleClose={handleViewClose}
          setShow={setview}
          show={view}
          id={view}
          getDataAll={getDataAll}
        />
      ) : (
        ""
      )}

      {show1 ? (
        <EditOffCanvance
          handleClose={handleClose1}
          setShow={setShowEdit}
          show={show1}
        />
      ) : (
        ""
      )}

      <Toaster position="top-right" />

      {/* <!-- Modal Delete --> */}
      <div className="upload-modal">
        <div
          className={`modal fade ${showDeleteModal ? "show" : ""}`}
          style={{ display: showDeleteModal ? "block" : "none" }}
          id="exampleModaldel"
          tabIndex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog  modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body">
                <h1 className="add-success text-center  mt-2">
                  Are you sure ?
                </h1>
                <p>
                  Do You Really Want to Delete These Record?
                  <br /> This Process CanNot Be Undone{" "}
                </p>
                <div className="button-holder text-center mt-2">
                  <button className="btn btn-yes me-2" onClick={DeleteRecord}>
                    Yes
                  </button>
                  <button className="btn btn-no" onClick={handleDeleteCancel}>
                    No
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Tables;
